<template>
    <div>
        <h4 class="text-center">ปรับค่าคอมมิชชั่นรายประเภทสินค้า</h4>
        <div class="row form-group">
            <div class="col-4 text-right">
                <label>ประเภทสินค้า</label>
            </div>
            <div class="col-6">
                <multiselect
                    v-model="form.product_type"
                    :options="optionProductType"
                    track-by="id"
                    :show-labels="false"
                    :custom-label="LabelName"
                    placeholder="เลือกประเภทสินค้า">
                </multiselect>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">
                <label>คอมมิชชั่น (%)</label>
            </div>
            <div class="col-6">
                <input type="number" placeholder="0.00" v-model="form.commission" class="form-control" />
            </div>
        </div>
        <div class="col text-center">
            <button class="btn btn-success" @click="submitData">บันทึก</button>&nbsp;
            <button class="btn btn-outline-secondary" @click="cancelData">ยกเลิก</button>&nbsp;
        </div>
    </div>
</template>

<script>
    import Multiselect from "vue-multiselect";
    import { mapState } from "vuex";
    export default {
        name: "CommissionProductModal",
        components:{
            Multiselect,
        },
        data(){
          return{
              form : {
                  product_type : '',
                  commission : '',
              }
          }
        },
        computed :{
            ...mapState({
                optionProductType : state =>{
                    return state.ProductType.data;
                },
            }),
        },
        methods:{
            LabelName (option) {
                return `${option.type_code} - ${option.name}`
            },
            submitData(){
                if (!this.form.product_type){
                    alert('กรุณาเลือกประเภทสินค้า');
                }else{
                    let data = {
                        product_type : this.form.product_type ? this.form.product_type.id : '',
                        commission : this.form.commission,
                    }
                    this.$emit('submit',data);
                }
            },
            cancelData(){
                this.$emit('submit',false);
            }
        }
    }
</script>

<style scoped>

</style>
